import { Button } from "antd";
import { get } from "lodash";
import querystring from "querystring";
import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { getQueryString, isMobile } from "../../utils/common";
import axios from "../../utils/selfRequest";
import { language } from "@/utils/language";  
import "./index.less";
// 测试页
export default function Endpage({ props, history }) {
  const thisTest = getQueryString("test");
  const thisSuveryid = getQueryString("surveryId");
  const thisQuestionid = getQueryString("questionId");
  const location = useLocation();
  const query = useMemo(() => {
    return querystring.parse(location.search.slice(1));
  }, [location.search]);
  let statusMessage = sessionStorage.getItem("statusMessage") || "";
  const [surveyInfo, setSurveyInfo] = useState({ alias: "" });
  // 获取问卷信息
  useEffect(() => {
    axios.get(`answer/test/surveyInfo/${thisSuveryid}`).then((res) => {
      const indata = res.data || {};
      statusMessage = indata.statusMessage;
      setSurveyInfo(indata);
    });
  }, [thisSuveryid]);
  const endUrl = () => {
    window.location.href = surveyInfo.preferences.endUrl;
  };

  // set theme
  useEffect(() => {
    if (isMobile) {
      document.body.style.cssText = `background: url(${surveyInfo.themeMoImage}) no-repeat fixed center/100% 100% content-box; font-size: ${surveyInfo?.preferences?.h5FontSize};`;
    } else {
      document.body.style.cssText = `background: url(${surveyInfo.themePcImage}) no-repeat fixed center/100% 100% content-box; font-size: ${surveyInfo?.preferences?.pcFontSize};`;
    }
  }, [surveyInfo]);

  useEffect(() => {
    try {
      let viedos = Array.from(document.getElementsByTagName("video"));
      if (viedos && viedos.length > 0) {
        viedos.forEach((element, index) => {
          element.play().catch((error) => {
            // 当播放异常时，走异常流程
            console.error("浏览器不支持这样做");
          });
        });
      }
    } catch (error) {
      console.error(error);
    }
  }, []);
  return (
    <div className="testlist-layout">
      <div className="layout-header">
        <div className="survey-title" style={{ color: surveyInfo.themeColor }}>
           {language().end}
        </div>
      </div>
      <div className="layout-body">
        <div className="question-content">
          <div className="base-checkbox" style={{ minHeight: "85vh" }}>
            <div className="q-content">
              <h3
                className="survey-title"
                dangerouslySetInnerHTML={{
                  __html: statusMessage
                    ? statusMessage
                        .replace(/<pre><code>(.*?)<\/code><\/pre>/g, "")
                        .replace(/<p><\/p>/g, "<br />")
                        .replace(/\n\n/g, "<br />")
                        .replace(/\s{2}/g, "&nbsp;&nbsp;")
                    : "",
                }}
              ></h3>
              <div style={{ display: "flex", justifyContent: "center" }}>
                {surveyInfo?.preferences?.endUrl &&
                  surveyInfo?.preferences?.endUrl !== "http://" && (
                    <Button
                      type="primary"
                      onClick={endUrl}
                      style={{
                        height: "50px",
                        width: "200px",
                        borderRadius: "10px",
                      }}
                    >
                       {language().end_click}
                    </Button>
                  )}
              </div>

              {thisTest === "1" && (
                <ul>
                  <li
                    onClick={() => {
                      history.push(
                        `/Questionnaire?endBack=true&endbackId=${thisSuveryid}&test=${thisTest}`
                      );
                    }}
                  >
                    {language().go_home_page}
                  </li>
                  <li
                    onClick={() => {
                      history.push(
                        `/Questionnaire?backlastSuveryid=${thisSuveryid}&backlastQuestionid=${thisQuestionid}&backLast=true&test=${thisTest}`
                      );
                    }}
                  >
                    {language().go_back}
                     
                  </li>
                </ul>
              )}
            </div>
            <style>
              {
                `
                li {
                  list-style-type: none;
                }
                `
              }
            </style>
          </div>
        </div>
      </div>
    </div>
  );
}
